import Plugin from '../core/Plugin';
import LiveScheduler from './scheduler/LiveScheduler';
import VodScheduler from './scheduler/VodScheduler';
import {PlayerEvent} from "../PlayerEvents";

/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export default class Scheduler extends Plugin {
  constructor() {
    super();
    this._schedulerCfg = null;
    this._scheduler = null;
  }

  init(opts = {}) {
    // 接口地址：http://yapi.vhall.domain/project/56/interface/api/19761
    // 接口地址：http://yapi.vhall.domain/project/56/interface/api/42383
    // plugin_scheduler参数示例：
    // {
    //   "url": "https://test-mss.vhall.com",
    //   "live_type": 0,
    //   "live_subtitle": 1,
    //   "live_delay": 0,
    //   "webinar_id": "lss_4b2365d4",
    //   "uid": "405",
    //   "bu": 1,
    //   "quality": [],
    //   "defaultDef": "same",
    //   "cipher_key": null,
    // }
    this._allConfig = opts;
    this._schedulerCfg = JSON.parse(opts[Scheduler.type]);

    // 分为直播调度和点播调度，两种实现
    this._isLive = opts['isLive'];
    this._scheduler = this._isLive ? new LiveScheduler() : new VodScheduler();
    this._scheduler.type = this._allConfig.type;
    this._scheduler.player = this.player;
    this._scheduler.option = this._schedulerCfg;
    this._scheduler.is_live = this._isLive;
    if (!this._isLive) {
      this._scheduler.vod_video_uri = this._allConfig.vod_video_uri
    }

    // hls内核和native内核都可以点播hls视频，目前只有hls内核可以解密
    if (!this._isLive && this.player.player._type === 'HlsPlayer' && this._schedulerCfg.cipher_key) {
      this.player.player.cipher_key = this._schedulerCfg.cipher_key;
    }

    // 发起调度请求，具体结果处理逻辑在实例中实现
    this._scheduler.fetch();
  }

  refreshDispatch() {
    this._scheduler && this._scheduler.fetch();
  }

  static get type() {
    return 'plugin_scheduler';
  }
}
